export { default } from './DoughnutChartMonitoring';
